import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:4f16182e-35b3-42e9-88dc-db614f9de4c7",
    aws_user_pools_id: "us-east-1_MOeCfPHyQ",
    aws_user_pools_web_client_id: "63q5d3tditi853nnpuu9be2ukb",
    Auth: {
      identityPoolId: "us-east-1:4f16182e-35b3-42e9-88dc-db614f9de4c7",
      region: "us-east-1",
      userPoolId: "us-east-1_MOeCfPHyQ",
      userPoolWebClientId: "63q5d3tditi853nnpuu9be2ukb",
    },
    oauth: {
      domain: `whs-navigator-beta-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://beta.na.navigator.whs.amazon.dev",
      redirectSignOut: "https://beta.na.navigator.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
